import React, { Component } from 'react';

import { trans } from '../../../../../localization';
import CustomerPaymentBy from './CustomerPaymentBy';

import defaultAvatarIcon from '../../../../../assets/common/images/icon/avatar-default.png';

class CustomerInfo extends Component {
  render() {
    const { orderUser, customerPay } = this.props;
    const {
      name,
      total_orders: totalOrders,
      avatar_url: avatarUrl,
    } = orderUser;

    const isDefaultAvatar = /user-default-(male|female).png$/i.test(avatarUrl);

    return (
      <div className="mt-2 col-3">
        <strong className="text-red">
          {trans('mod_order_detail_customer_info')}
        </strong>
        <div className="p-2">
          <div className="row mb-1">
            <div style={{ marginLeft: '10px', width: '50px', height: '50px' }}>
              <img
                alt={name}
                src={
                  !isDefaultAvatar
                    ? avatarUrl || defaultAvatarIcon
                    : defaultAvatarIcon
                }
                style={{ borderRadius: '100%', width: '50px' }}
              />
            </div>
            <div style={{ paddingLeft: '20px' }}>
              <div className="row mb-1">
                <strong className="text-black">{name}</strong> &nbsp;
                <CustomerPaymentBy customerPay={customerPay} />
              </div>
              <div className="row mb-1">
                {trans('mod_order_detail_total_order')}: &nbsp;
                {totalOrders}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CustomerInfo;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/CustomerInfo.jsx